var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseMarkdown',{directives:[{name:"improve-links",rawName:"v-improve-links"}],staticClass:"PostContentMarkdown post-content-markdown",attrs:{"text":_vm.data.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }